import SimpleLogo from "@ui/components/brand/overtone/SimpleLogo/SimpleLogo";
import Button from "@ui/components/cta/Button/Button";
import PrimaryNavigation from "@ui/components/navigation/Navigation/components/PrimaryNavigation";
import HamburgerButtonMobile from "@ui/components/navigation/Navigation/components/PrimaryNavigation/components/PrimaryNavigationMobile/components/HamburgerButton/HamburgerButton";
import LinkButton from "@ui/components/navigation/Navigation/components/PrimaryNavigation/components/PrimaryNavigationMobile/components/LinkButton";
import HamburgerButtonDesktop from "@ui/components/navigation/Navigation/components/PrimaryNavigation/components/PrimaryNavigationStandard/components/HamburgerButton/HamburgerButton";
import StickyNav from "@ui/components/navigation/Navigation/components/StickyNav";
import { NavigationConfig } from "@ui/context/component-config-context";

import * as styles from "./Navigation.overtone.config.css";

const navigationConfig: NavigationConfig = {
  Logo: SimpleLogo,
  showAuth: false,
  showStickyNavCommentCount: false,
  showSubscribeInNav: false,
  stickyNavComponent: StickyNav,
  getDrawerComponents: () => ({}),
  primaryNavigationComponent: PrimaryNavigation,
  linkMenu: {
    showLinkLines: false,
    linkClassName: styles.linkMenuLink,
  },
  rightMenuButtons: {
    desktop: (props) => <HamburgerButtonDesktop {...props} />,
    mobile: (props) => <HamburgerButtonMobile {...props} />,
  },
  cta: {
    desktop: <Button displayType="primary" text={"Call to Action"} />,
    mobile: <LinkButton text={"Call to Action"} />,
  },
  drawerItems: [
    {
      title: "Duet UI Docs",
      url: "https://duet-docs.voxops.net/packages/duet-ui/overview/index.html",
      subItems: [],
    },
  ],
  getPinnedItems: () => [],
  componentContext: {},
};

export default navigationConfig;
